export default __webpack_public_path__ + "static/media/clients_m.16c91c2b.jpg";